<template>
  <div class="container clinic-packs">
    <clinic-show-pack ref="showpack" @submit="searchPacks"></clinic-show-pack>

    <!-- HEADER -->
    <div class="row mb-3">
      <div class="col-sm-10 text-left">
        <h1 class="page-title">PACKS DE TRATAMIENTOS</h1>
      </div>
      <div class="col-sm-2 text-center">
        <button @click="addNewPack" type="button" class="btn btn-wabident-round btn-block">
          <i class="fas fa-plus mr-2"></i> Nuevo
        </button>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <input v-model="search" class="form-control icon" type="search" name="search" id="pack_index_search"
          placeholder="Escribe el nombre del pack" />
      </div>
    </div>

    <!-- RESULTS -->
    <div class="row">
      <div class="col-sm-12">
        <div v-show="!has_results_available" class="text-center">
          <h2 class="pack-search-empty-message my-4">{{ empty_message }}</h2>
        </div>
        <div v-show="has_results_available" class="pack-search-wrapper">
          <table class="table pack-search-results">
            <thead>
              <tr>
                <th style="width:10%" class="text-center">ID</th>
                <th>NOMBRE</th>
              </tr>
            </thead>
            <tbody>
              <tr class="pack-search-results__row" v-for="(pack, index) in packs" :key="index" @click="packClicked(pack)">
                <td style="width:10%" class="text-center">
                  {{ pack.id }}
                </td>
                <td>
                  {{ pack.name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-show="has_results_available" class="pack-search-pagination text-center">
          <button @click="goFirst" :disabled="is_first_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button @click="goPrev" :disabled="is_first_page" type="button" class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-left"></i>
          </button>
          <label class="customer-search-pagination-locator mx-2">
            Página
            {{ current_page }} de {{ total_pages }}
          </label>
          <button @click="goNext" :disabled="is_last_page" type="button" class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-right"></i>
          </button>
          <button @click="goLast" :disabled="is_last_page" type="button" class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      search: "",
      search_results: [],
      is_searching: false,
      selected_pack: null,
      hierarchy: [],
    };
  },
  computed: {
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == this.search_results.last_page;
    },
    current_page() {
      if (!this.search_results) return 0;
      return this.search_results.current_page;
    },
    total_pages() {
      if (!this.search_results) return 0;
      return this.search_results.last_page;
    },
    packs() {
      if (!this.search_results) return [];
      if (!this.search_results.data) return [];

      return this.search_results.data;
    },
    has_results_available() {
      return this.packs.length != 0;
    },
    empty_message() {
      if (this.search == "") {
        return "";
      } else {
        return "Lo siento, no pude encontrar ningún Pack con ese nombre";
      }
    },
    ...mapGetters(["msgwindow", "clinic"]),
  },
  watch: {
    search(val) {
      this.searchPacks(0);
    },
  },
  methods: {
    goNext() {
      this.searchPacks(this.current_page + 1);
    },
    goPrev() {
      this.searchPacks(this.current_page - 1);
    },
    goFirst() {
      this.searchPacks(1);
    },
    goLast() {
      this.searchPacks(this.total_pages);
    },
    userCan(capability) {
      if (!this.clinic) return false;
      return this.clinic.capabilities[capability] || false;
    },
    addNewPack() {
      this.$refs.showpack.showNew();
    },
    packClicked(pack) {
      if (!this.userCan('agenda_only')) {
        this.$refs.showpack.showEdit(pack);
      }
    },
    onSubmit() {
      this.searchPacks(this.current_page);
    },
    searchPacks(page = null) {
      if (!this.is_searching) {
        this.is_searching = true;
        let params = {
          search: this.search,
        };

        if (page) {
          params.page = page;
        }

        axios
          .get("/pack", { params })
          .then((response) => {
            this.search_results = response.data;
          })
          .catch((err) => {
            console.log("[ERR] searchPacks", err);
            this.msgwindow.error("Error buscando Packs");
          })
          .then(() => {
            this.is_searching = false;
          });
      }
    },
  },
  mounted() {
    this.searchPacks();
  },
};
</script>

<style lang="scss">
.clinic-packs {
  margin-top: 54px;
}

.page-title {
  font-size: 32px;
  color: var(--theme-text-color);
  letter-spacing: 0.5px;
  line-height: 1.31;
  font-weight: 800;
  margin-bottom: 27px;
}

.pack-search-empty-message {
  color: var(--theme-grey);
  font-size: 24px;
}

.pack-search-wrapper {
  margin-top: 30px;
  width: 100%;
}

.pack-search-results {
  width: 100%;

  th {
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
    position: sticky;
    background-color: white;
    top: 0;
  }

  &__row {
    cursor: pointer;
    background-color: transparent;
    transition: all 0.2s;
    border: none;
    border-bottom: 1px #e0e0e0 solid;

    &:hover {
      background-color: var(--theme-highlight);
    }

    td {
      font-size: 16px;
      line-height: 20px;
      color: var(--theme-text-color);

      &.pack-code,
      &.pack-icon {
        color: var(--theme-grey);
        text-transform: uppercase;

        svg {
          fill: currentColor;
        }
      }
    }
  }
}
</style>
